/* THE PAW EDIT™ storefront script. Reads live store data from #PawData, rendered by
   sections/paw-edit-homepage.liquid or sections/paw-edit-collection.liquid. Page-specific
   modules only run when their elements are on the page. */
(function () {
document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

/* =====================================================================
   DATA: live store data rendered by Liquid into #PawData
   ===================================================================== */
const DATA = JSON.parse(document.getElementById('PawData').textContent);

/* Design content (edit here): which category each product belongs to, and its short quick-view description */
const CATEGORY_MAP = {"recordable-jumping-squeaky-dog-toy-with-music-modes":"play","adjustable-treat-dispensing-puzzle-ball-for-dogs":"play","tough-tug-fetch-dog-soccer-ball-with-grab-straps":"play","round-cotton-rope-cat-scratcher-mat-15-7-inch":"play","duck-treat-dispenser-slow-feeder-puzzle-bowl":"play","heartbeat-comfort-puppy-toy-soft-cuddle-companion":"play","collapsible-cat-crinkle-tunnel-with-plush-toys":"play","catnip-kicker-fish-toy-crinkle-chew-for-indoor-cats":"play","door-hanging-cat-teaser-toys-2-pack":"play","motion-activated-cat-ball-with-teaser-tail":"play","2-in-1-dog-bath-brush-with-shampoo-dispenser":"groom","fast-drying-dog-bathrobe-towel-super-absorbent":"groom","wall-corner-cat-self-groomer-with-catnip-2-pack":"groom","3-in-1-steam-grooming-brush-massage-spray-deshed":"groom","lick-roll-slow-feeder-bowl-no-mess-rolling-ball":"feed","adjustable-height-raised-pet-bowl-with-suction-base":"feed","travel-water-bottle-bowl-10-oz-stainless-steel":"feed","silicone-pet-grooming-glove-hair-remover-mitt":"groom","dematting-undercoat-comb-for-tangled-coats":"groom","one-touch-self-cleaning-slicker-brush":"groom","quiet-pet-nail-grinder-with-dual-led-lights":"groom","soft-silicone-tongue-comb-for-cats-dogs":"groom","reusable-washable-lint-roller-travel-size-fur-remover":"home","foldable-organ-cat-scratcher-with-bell-ball":"play","hand-woven-cotton-rope-cat-bed-with-play-ball":"rest","donut-cat-tunnel-bed-2-in-1-play-tunnel-nest":"play","natural-rubber-carrot-chew-toy-for-tough-chewers":"play","back-seat-pet-barrier-storage-organizer-3-layer":"walk","oversized-novelty-chain-leash-6-ft-lightweight":"walk","banana-cuddle-cat-bed-soft-enclosed-sleeping-cave":"rest","self-adhesive-furniture-scratch-guard-for-cats":"home","self-cleaning-pet-fur-roller-with-base-station":"home","potty-training-door-bells-adjustable-hanging-dog-bells":"home","cooling-pet-house-ventilated-summer-nest-for-cats-dogs":"rest","hands-free-running-waist-leash-with-bungee-lead":"walk","raised-double-bowl-feeding-stand-non-slip":"feed","dog-car-seat-belt-tether-reflective-bungee-2-pack":"walk","waterproof-back-seat-dog-hammock-with-mesh-window":"walk","hooded-plush-cave-cat-bed-washable-non-slip-base":"rest","breathable-pet-sling-carrier-with-leash-clip":"walk","cordless-paw-trimmer-with-led-light-wide-blade":"groom","reversible-flannel-pet-blanket-crate-mat":"rest","breathable-mesh-pet-carrier-backpack-front-or-back-wear":"walk","dual-retractable-leash-with-led-light-no-tangle-swivel":"walk"};
const BLURBS = {"recordable-jumping-squeaky-dog-toy-with-music-modes":"A plush jumping toy with a squeaker, music modes and a recordable voice feature for interactive play.","adjustable-treat-dispensing-puzzle-ball-for-dogs":"A treat-dispensing puzzle toy in rigid nylon, about 7.6 × 3 in. Not intended for large dogs with aggressive chewing habits.","tough-tug-fetch-dog-soccer-ball-with-grab-straps":"A soccer-style ball with fabric grab straps for tug, fetch and backyard play.","round-cotton-rope-cat-scratcher-mat-15-7-inch":"A 15.7-inch round cotton rope scratching mat with a hanging loop and an attached ball toy.","duck-treat-dispenser-slow-feeder-puzzle-bowl":"A duck-shaped puzzle bowl that works as both a treat dispenser and a slow feeder.","heartbeat-comfort-puppy-toy-soft-cuddle-companion":"A soft plush puppy companion with a built-in heartbeat feature, sized for crates and travel.","collapsible-cat-crinkle-tunnel-with-plush-toys":"A collapsible crinkle tunnel for cats that comes with plush toys and folds flat for storage.","catnip-kicker-fish-toy-crinkle-chew-for-indoor-cats":"A fish-shaped kicker toy with catnip and a crinkle layer, made for indoor cats.","door-hanging-cat-teaser-toys-2-pack":"Two plush teaser toys that hang from a door, with adjustable length and a fluffy mouse at the end.","motion-activated-cat-ball-with-teaser-tail":"A motorized ball with a feathered teaser tail that moves across the floor.","2-in-1-dog-bath-brush-with-shampoo-dispenser":"A soft silicone bath brush with a built-in shampoo dispenser for dogs and cats.","fast-drying-dog-bathrobe-towel-super-absorbent":"A hooded, striped bathrobe towel that wraps around your dog after bath time.","wall-corner-cat-self-groomer-with-catnip-2-pack":"Two wall-corner rubbing combs with catnip, so cats can groom themselves.","3-in-1-steam-grooming-brush-massage-spray-deshed":"A USB-rechargeable grooming brush with a fine water mist for lifting loose hair.","lick-roll-slow-feeder-bowl-no-mess-rolling-ball":"A slow-feeder bowl with a rolling ball that releases food or liquid treats as your pet licks.","adjustable-height-raised-pet-bowl-with-suction-base":"A raised bowl with three height settings and a detachable suction base.","travel-water-bottle-bowl-10-oz-stainless-steel":"A lightweight 10 oz stainless steel bottle with a fold-out bowl and a carry rope.","silicone-pet-grooming-glove-hair-remover-mitt":"A grooming mitt for lifting pet hair from sofas, carpets and clothes.","dematting-undercoat-comb-for-tangled-coats":"A dematting comb for working through tangles and loose undercoat.","one-touch-self-cleaning-slicker-brush":"A slicker brush with one-touch bristle release, so collected hair wipes straight off.","quiet-pet-nail-grinder-with-dual-led-lights":"A 2-in-1 nail trimmer and grinder with dual LED lights.","soft-silicone-tongue-comb-for-cats-dogs":"A soft comb with teeth modelled on a cat’s tongue, about 7.9 × 3 in.","reusable-washable-lint-roller-travel-size-fur-remover":"A reusable, washable lint roller in travel size for fur on the go.","foldable-organ-cat-scratcher-with-bell-ball":"A foldable scratcher that opens into different shapes, with a bell ball.","hand-woven-cotton-rope-cat-bed-with-play-ball":"A hand-woven cotton rope bed with a play ball, in 15.7 in and 18.9 in diameters.","donut-cat-tunnel-bed-2-in-1-play-tunnel-nest":"A plush donut tunnel that works as both a play tunnel and a nest.","natural-rubber-carrot-chew-toy-for-tough-chewers":"An 8-inch natural rubber carrot chew toy for small, medium and large dogs.","back-seat-pet-barrier-storage-organizer-3-layer":"A 3-layer organizer that fits between the front seats, adding storage and a barrier.","oversized-novelty-chain-leash-6-ft-lightweight":"A 6 ft leash with an oversized, lightweight chain-link look.","banana-cuddle-cat-bed-soft-enclosed-sleeping-cave":"A banana-shaped enclosed plush bed for cats, kittens and other small pets.","self-adhesive-furniture-scratch-guard-for-cats":"A self-adhesive felt scratch pad (11.8 × 23 in) that covers furniture edges.","self-cleaning-pet-fur-roller-with-base-station":"A reusable fur roller with a self-cleaning base station, with no sticky sheets to replace.","potty-training-door-bells-adjustable-hanging-dog-bells":"Adjustable hanging door bells for house and potty training.","cooling-pet-house-ventilated-summer-nest-for-cats-dogs":"A ventilated summer house for cats and dogs, available in several sizes.","hands-free-running-waist-leash-with-bungee-lead":"A hands-free waist-belt leash with a stretch bungee lead and reflective stitching.","raised-double-bowl-feeding-stand-non-slip":"A raised double-bowl stand with a 15° tilt and non-slip base; the bowls lift out.","dog-car-seat-belt-tether-reflective-bungee-2-pack":"Two adjustable car seat-belt tethers (25–32 in) with reflective bungee sections.","waterproof-back-seat-dog-hammock-with-mesh-window":"A waterproof back-seat hammock with a mesh window that covers your car’s rear seats.","hooded-plush-cave-cat-bed-washable-non-slip-base":"A hooded plush cave bed with a washable build and non-slip base, 25 × 25 × 19 in.","breathable-pet-sling-carrier-with-leash-clip":"A breathable sling carrier with a leash clip for carrying small pets close.","cordless-paw-trimmer-with-led-light-wide-blade":"A cordless paw trimmer with an LED light and a wide blade for tidying paw fur.","reversible-flannel-pet-blanket-crate-mat":"A reversible flannel blanket that doubles as a crate or sofa mat, in six sizes.","breathable-mesh-pet-carrier-backpack-front-or-back-wear":"A breathable mesh carrier with a legs-out design, worn on the front or back.","dual-retractable-leash-with-led-light-no-tangle-swivel":"A dual retractable leash with an LED light and no-tangle swivel, for two small dogs under 8 kg."};

const CONFIG = {
  currency: DATA.currency || 'USD',
  locale: DATA.locale || 'en',
  heroIntervalMs: 7000,          // keep in sync with --hero-interval in CSS
  discoveryPageSize: 8,
  announcements: DATA.announcements,
  marquee: (DATA.marquee || []).map(s => s.trim()).filter(Boolean),
};
const ROOT = (DATA.root || '/').replace(/\/?$/, '/');

const BANNERS = DATA.banners;

const CATEGORIES = [
  { id: 'walk',  label: 'Walking & Travel',   nav: 'Walk & Travel', cover: 'dual-retractable-leash-with-led-light-no-tangle-swivel' },
  { id: 'rest',  label: 'Comfort & Rest',     nav: 'Rest',          cover: 'hooded-plush-cave-cat-bed-washable-non-slip-base' },
  { id: 'groom', label: 'Grooming & Care',    nav: 'Grooming',      cover: 'one-touch-self-cleaning-slicker-brush' },
  { id: 'feed',  label: 'Feeding',            nav: 'Feeding',       cover: 'lick-roll-slow-feeder-bowl-no-mess-rolling-ball' },
  { id: 'play',  label: 'Play & Enrichment',  nav: 'Play',          cover: 'catnip-kicker-fish-toy-crinkle-chew-for-indoor-cats' },
  { id: 'home',  label: 'Home & Training',    nav: 'Home',          cover: 'self-cleaning-pet-fur-roller-with-base-station' },
];

const HERO_SLIDES = [
  { banner: 'walkPromenade', eyebrow: 'The Walking Edit',
    heading: 'Two leads, <em class="h-italic">one easy stroll.</em>',
    text: 'The Dual Retractable Leash pairs an LED light with a no-tangle swivel, made for walking two small dogs together.',
    product: 'dual-retractable-leash-with-led-light-no-tangle-swivel', productCta: 'Shop the leash',
    category: 'walk', categoryCta: 'Walking & travel' },
  { banner: 'soccerPlay', eyebrow: 'Play & Enrichment',
    heading: 'Made for the <em class="h-italic">good kind of chaos.</em>',
    text: 'The Tough Tug & Fetch Soccer Ball has fabric grab straps for tug-of-war, fetch and long afternoons on the lawn.',
    product: 'tough-tug-fetch-dog-soccer-ball-with-grab-straps', productCta: 'Shop the ball',
    category: 'play', categoryCta: 'All play' },
  { banner: 'caveBed', eyebrow: 'Comfort & Rest',
    heading: 'A softer <em class="h-italic">place to land.</em>',
    text: 'The Hooded Plush Cave Bed is a washable, enclosed hideaway with a non-slip base.',
    product: 'hooded-plush-cave-cat-bed-washable-non-slip-base', productCta: 'Shop the bed',
    category: 'rest', categoryCta: 'Beds & blankets' },
];

const FEATURED = [
  'dual-retractable-leash-with-led-light-no-tangle-swivel',
  'hooded-plush-cave-cat-bed-washable-non-slip-base',
  'one-touch-self-cleaning-slicker-brush',
  'tough-tug-fetch-dog-soccer-ball-with-grab-straps',
  'travel-water-bottle-bowl-10-oz-stainless-steel',
  'breathable-mesh-pet-carrier-backpack-front-or-back-wear',
  'fast-drying-dog-bathrobe-towel-super-absorbent',
  'lick-roll-slow-feeder-bowl-no-mess-rolling-ball',
];

const EVERYDAY = [
  { banner: 'leashPark', title: 'Easier walks', cta: 'Shop walks', category: 'walk',
    text: 'Two-dog, hands-free and statement leashes for everyday routes.',
    items: ['dual-retractable-leash-with-led-light-no-tangle-swivel', 'hands-free-running-waist-leash-with-bungee-lead', 'oversized-novelty-chain-leash-6-ft-lightweight'] },
  { banner: 'slicker', title: 'Cleaner grooming', cta: 'Shop grooming', category: 'groom',
    text: 'Brushes, combs and trimmers that collect loose hair where you want it.',
    items: ['one-touch-self-cleaning-slicker-brush', 'dematting-undercoat-comb-for-tangled-coats', 'cordless-paw-trimmer-with-led-light-wide-blade'] },
  { banner: 'sling', title: 'More comfortable travel', cta: 'Shop travel', category: 'walk',
    text: 'Slings, backpacks and car setups for short hops and long drives.',
    items: ['breathable-pet-sling-carrier-with-leash-clip', 'breathable-mesh-pet-carrier-backpack-front-or-back-wear', 'waterproof-back-seat-dog-hammock-with-mesh-window'] },
  { banner: 'catnipFish', title: 'Enriching play', cta: 'Shop play', category: 'play',
    text: 'Kicker toys, puzzle feeders and teasers for indoor play.',
    items: ['catnip-kicker-fish-toy-crinkle-chew-for-indoor-cats', 'adjustable-treat-dispensing-puzzle-ball-for-dogs', 'door-hanging-cat-teaser-toys-2-pack'] },
];

/* Normalise live products. Prices are in cents. */
/* Category membership comes from the collections picked in the section settings; CATEGORY_MAP is the fallback */
const CAT_DATA = DATA.categories || {};
const CAT_OF = {};
Object.keys(CAT_DATA).forEach(id => (CAT_DATA[id].handles || []).forEach(h => { if (!CAT_OF[h]) CAT_OF[h] = id; }));
CATEGORIES.forEach(c => { const d = CAT_DATA[c.id] || {}; c.url = d.url || ''; c.count = d.count; });
const ALL_URL = DATA.allUrl || '/collections/all';
const PRODUCTS = (DATA.products || []).map(p => ({
  ...p,
  category: CAT_OF[p.handle] || CATEGORY_MAP[p.handle] || '',
  blurb: BLURBS[p.handle] || p.desc || '',
  // option choices shown in quick view (none for single "Default Title" products)
  opts: p.defaultOnly ? [] : p.variants,
}));

/* =====================================================================
   HELPERS
   ===================================================================== */
const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => [...el.querySelectorAll(s)];
const byHandle = Object.fromEntries(PRODUCTS.map(p => [p.handle, p]));
const pick = handles => handles.map(h => byHandle[h]).filter(Boolean);
const catLabel = id => (CATEGORIES.find(c => c.id === id) || {}).label || '';
/* Link attributes for a category: its collection page when set, otherwise the on-page filter */
const catLink = id => {
  if (id === 'all') return `href="${esc(ALL_URL)}"`;
  const c = CATEGORIES.find(x => x.id === id);
  return c && c.url ? `href="${esc(c.url)}"` : `href="#discover" data-cat="${id}"`;
};
const tagLabel = p => catLabel(p.category) || p.type || '';
let fmt;
try { fmt = new Intl.NumberFormat(CONFIG.locale, { style: 'currency', currency: CONFIG.currency }); }
catch (e) { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }); }
const money = cents => fmt.format((cents || 0) / 100);
const priceText = p => (p.priceMax > p.price ? 'From ' : '') + money(p.price) + (p.available ? '' : ' · Sold out');
const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const sized = (url, w) => {
  if (!url) return '';
  if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
  return url + (url.includes('?') ? '&' : '?') + 'width=' + w;
};
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const ICON_ARROW = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
const ICON_PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
const placeholder = (label = 'Product image placeholder') =>
  `<div class="ph" role="img" aria-label="${esc(label)}"><strong>TPE</strong><span>Image to come</span></div>`;

function productImg(p, w, cls = '', lazy = true) {
  if (!p || !p.images.length) return placeholder(`Image placeholder for ${p ? p.title : 'product'}`);
  return `<img class="${cls}" src="${esc(sized(p.images[0], w))}" alt="${esc(p.title)}" ${lazy ? 'loading="lazy"' : ''} decoding="async" width="${w}" height="${w}">`;
}
/* With a tall mobile image (b.msrcset), phones up to 760px load it instead; see assets/paw-mobile.css */
function bannerImg(b, attrs = '') {
  if (!b || !b.src) return placeholder('Banner image missing: ' + (b ? b.alt : ''));
  const img = `<img ${b.msrcset ? 'class="has-m" ' : ''}src="${esc(b.src)}" ${b.srcset ? `srcset="${esc(b.srcset)}"` : ''} alt="${esc(b.alt)}" width="${b.w}" height="${b.h}" ${attrs}>`;
  return b.msrcset ? `<picture><source media="(max-width: 760px)" srcset="${esc(b.msrcset)}" sizes="100vw">${img}</picture>` : img;
}

/* Broken image fallback: swap any failed image for a labeled placeholder */
document.addEventListener('error', e => {
  const img = e.target;
  if (!(img instanceof HTMLImageElement) || img.dataset.failed || !img.closest('.paw-edit-root')) return;
  img.dataset.failed = '1';
  if (img.classList.contains('alt')) { img.remove(); return; }
  const holder = document.createElement('div');
  holder.innerHTML = placeholder('Image unavailable: ' + (img.alt || 'replace this image'));
  const ph = holder.firstElementChild;
  if (getComputedStyle(img.parentElement).position === 'static') img.parentElement.style.position = 'relative';
  img.replaceWith(ph);
}, true);

/* Toast */
let toastT;
function toast(msg) {
  const t = $('#toast'); $('#toastMsg').textContent = msg;
  t.classList.add('is-show'); clearTimeout(toastT);
  toastT = setTimeout(() => t.classList.remove('is-show'), 3200);
}

/* =====================================================================
   DIALOG HELPER (animated open/close, scroll lock, backdrop click)
   ===================================================================== */
const openDialogs = new Set();
function openDialog(d, opener) {
  if (d.open) return;
  d._opener = opener || document.activeElement;
  d.showModal();
  openDialogs.add(d);
  document.documentElement.style.overflow = 'hidden';
  requestAnimationFrame(() => requestAnimationFrame(() => d.classList.add('is-open')));
}
function closeDialog(d) {
  if (!d.open || d._closing) return;
  d._closing = true;
  d.classList.remove('is-open');
  reduceMotion.matches ? d.close() : setTimeout(() => d.open && d.close(), 420);
}
$$('.paw-edit-root dialog').forEach(d => {
  d.addEventListener('close', () => {
    d._closing = false; d.classList.remove('is-open'); openDialogs.delete(d);
    if (!openDialogs.size) document.documentElement.style.overflow = '';
    if (d._opener && document.contains(d._opener)) d._opener.focus({ preventScroll: true });
  });
  d.addEventListener('cancel', e => { e.preventDefault(); closeDialog(d); });
  d.addEventListener('keydown', e => { if (e.key === 'Escape') { e.preventDefault(); closeDialog(d); } });
  d.addEventListener('click', e => {
    if (e.target === d) closeDialog(d);                       // backdrop
    if (e.target.closest('[data-close]')) closeDialog(d);
  });
});

/* =====================================================================
   ANNOUNCEMENT BAR
   ===================================================================== */
(function announce() {
  const el = $('#announce');
  if (!CONFIG.announcements.length) { el.closest('.announce').hidden = true; return; }
  el.innerHTML = CONFIG.announcements.map((m, i) => `<p class="announce__msg${i ? '' : ' is-active'}" ${i ? 'aria-hidden="true"' : ''}>${esc(m)}</p>`).join('');
  const msgs = $$('.announce__msg', el); let i = 0, paused = false;
  el.addEventListener('mouseenter', () => paused = true);
  el.addEventListener('mouseleave', () => paused = false);
  if (msgs.length > 1 && !reduceMotion.matches) setInterval(() => {
    if (paused || document.hidden) return;
    msgs[i].classList.remove('is-active'); msgs[i].setAttribute('aria-hidden', 'true');
    i = (i + 1) % msgs.length;
    msgs[i].classList.add('is-active'); msgs[i].removeAttribute('aria-hidden');
  }, 5000);
})();

/* =====================================================================
   NAVIGATION (desktop, mobile, footer) + header scroll behaviour
   ===================================================================== */
(function nav() {
  const count = id => PRODUCTS.filter(p => p.category === id).length;
  // Header and mobile menus are rendered by Liquid from the menu chosen in the section settings.
  // These fallbacks only run if that menu is empty.
  if (!$('#primaryNav').children.length) $('#primaryNav').innerHTML = `<li><a ${catLink('all')}>Shop all</a></li>` +
    CATEGORIES.map(c => `<li><a ${catLink(c.id)}>${esc(c.nav)}</a></li>`).join('');
  if (!$('#mobileNav').children.length) $('#mobileNav').innerHTML = [{ id: 'all', label: 'Shop all' }, ...CATEGORIES].map((c, i) =>
    `<li style="transition-delay:${.08 + i * .05}s"><a ${catLink(c.id)}>${esc(c.label)} <small style="font-family:var(--font-body);font-size:13px;color:var(--muted)">${c.id === 'all' ? PRODUCTS.length : count(c.id)}</small></a></li>`).join('');
  $('#footShop').innerHTML = `<li><a ${catLink('all')}>Shop all</a></li>` + CATEGORIES.map(c => `<li><a ${catLink(c.id)}>${esc(c.label)}</a></li>`).join('');

  $('#menuOpen').addEventListener('click', e => openDialog($('#menuDrawer'), e.currentTarget));

  const header = $('#header'); let lastY = scrollY, ticking = false;
  addEventListener('scroll', () => {
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => {
      const y = scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      const hide = y > lastY && y > 480 && !header.contains(document.activeElement);
      header.classList.toggle('is-hidden', hide);
      lastY = y; ticking = false;
    });
  }, { passive: true });
})();

/* Global click delegation: category links, quick view, add */
document.addEventListener('click', e => {
  if (!e.target.closest || !e.target.closest('.paw-edit-root')) return;
  const cat = e.target.closest('[data-cat]');
  if (cat) {
    e.preventDefault();
    const d = cat.closest('dialog'); if (d) closeDialog(d);
    const filter = Discovery || Browse;
    if (filter) filter.select(cat.dataset.cat, true);
    return;
  }
  const qv = e.target.closest('[data-qv]');
  if (qv) {
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;           // allow open-in-new-tab
    e.preventDefault(); QuickView.open(qv.dataset.qv, qv); return;
  }
  const add = e.target.closest('[data-add]');
  if (add) {
    e.preventDefault();
    const p = byHandle[add.dataset.add]; if (!p) return;
    if (p.variants.length > 1) { QuickView.open(p.handle, add); return; }
    const v = p.variants[0];
    if (!v || !v.available) { toast('Sorry, this item is sold out.'); return; }
    add.disabled = true;
    Cart.add(v.id, 1, p.title).then(ok => {
      add.disabled = false;
      if (ok) { add.classList.add('added'); setTimeout(() => add.classList.remove('added'), 1200); }
    });
    return;
  }
});

/* =====================================================================
   HERO CAROUSEL
   ===================================================================== */
const Hero = (function () {
  const root = $('#hero'), vp = $('#heroViewport'), dots = $('#heroDots');
  if (!root) return null;
  const n = HERO_SLIDES.length; let idx = 0, userPaused = false, hoverPaused = false;
  vp.innerHTML = HERO_SLIDES.map((s, i) => {
    const b = BANNERS[s.banner] || {};
    const p = byHandle[s.product];
    return `<div class="hero__slide${i ? '' : ' is-active'}" role="group" aria-roledescription="slide" aria-label="${i + 1} of ${n}" ${i ? 'aria-hidden="true" inert' : ''}>
      <div class="hero__media">${bannerImg(b, `sizes="100vw" style="--pos:${esc(b.pos)};--pos-m:${esc(b.posM || b.pos)}" ${i ? 'decoding="async"' : 'fetchpriority="high"'}`)}</div>
      <div class="hero__content"><div class="container"><div class="hero__copy">
        <span class="eyebrow">${esc(s.eyebrow)}</span>
        <h2>${s.heading}</h2>
        <p class="hero__text">${esc(s.text)}</p>
        <div class="hero__ctas">
          ${p ? `<a class="btn" href="${esc(p.url)}">${esc(s.productCta)} <span class="arrow">${ICON_ARROW}</span></a>` : ''}
          <a class="btn btn--ghost" ${catLink(s.category)}>${esc(s.categoryCta)}</a>
        </div>
      </div></div></div>
    </div>`;
  }).join('');
  dots.innerHTML = HERO_SLIDES.map((s, i) => `<button class="hero__dot" aria-label="Go to slide ${i + 1}: ${esc(s.eyebrow)}" aria-current="${i === 0}"><span class="track"><span class="bar"></span></span></button>`).join('');
  const slides = $$('.hero__slide', vp), dotEls = $$('.hero__dot', dots);

  function go(i, fromUser) {
    i = (i + n) % n; if (i === idx && !fromUser) return;
    slides[idx].classList.remove('is-active'); slides[idx].setAttribute('aria-hidden', 'true'); slides[idx].inert = true;
    dotEls[idx].setAttribute('aria-current', 'false');
    idx = i;
    slides[idx].classList.add('is-active'); slides[idx].removeAttribute('aria-hidden'); slides[idx].inert = false;
    const bar = $('.bar', dotEls[idx]); bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = '';
    dotEls[idx].setAttribute('aria-current', 'true');
    $('#heroCount').textContent = String(idx + 1).padStart(2, '0') + ' / ' + String(n).padStart(2, '0');
  }
  dots.addEventListener('animationend', e => { if (e.animationName === 'heroProgress') go(idx + 1); });
  dotEls.forEach((d, i) => d.addEventListener('click', () => go(i, true)));
  $('#heroPrev').addEventListener('click', () => go(idx - 1, true));
  $('#heroNext').addEventListener('click', () => go(idx + 1, true));

  function syncPause() { root.classList.toggle('is-paused', userPaused || hoverPaused); }
  const pauseBtn = $('#heroPause');
  function setUserPaused(v) {
    userPaused = v; syncPause();
    pauseBtn.setAttribute('aria-label', v ? 'Play slideshow' : 'Pause slideshow');
    $('#heroPauseIcon').innerHTML = v ? '<path d="M8 5.5v13l10.5-6.5z"/>' : '<rect x="7" y="6" width="3.2" height="12" rx="1"/><rect x="13.8" y="6" width="3.2" height="12" rx="1"/>';
    if (reduceMotion.matches) root.classList.toggle('no-autoplay', v);
  }
  pauseBtn.addEventListener('click', () => setUserPaused(!userPaused));
  root.addEventListener('mouseenter', () => { hoverPaused = true; syncPause(); });
  root.addEventListener('mouseleave', () => { hoverPaused = false; syncPause(); });
  root.addEventListener('focusin', () => { hoverPaused = true; syncPause(); });
  root.addEventListener('focusout', e => { if (!root.contains(e.relatedTarget)) { hoverPaused = false; syncPause(); } });
  document.addEventListener('visibilitychange', () => { hoverPaused = document.hidden; syncPause(); });

  let x0 = null, y0 = null;
  vp.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; hoverPaused = true; syncPause(); }, { passive: true });
  vp.addEventListener('touchend', e => {
    if (x0 === null) return;
    const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1), true);
    x0 = null; setTimeout(() => { hoverPaused = false; syncPause(); }, 2500);
  });
  root.addEventListener('keydown', e => {
    if (e.key === 'ArrowRight') { go(idx + 1, true); }
    if (e.key === 'ArrowLeft') { go(idx - 1, true); }
  });

  if (reduceMotion.matches) { root.classList.add('no-autoplay'); setUserPaused(true); }
  $('#heroCount').textContent = '01 / ' + String(n).padStart(2, '0');
  return { go };
})();

/* =====================================================================
   COLLECTION NAV
   ===================================================================== */
(function collections() {
  if (!$('#collList')) return;
  $('#collList').innerHTML = CATEGORIES.map((c, i) => {
    const p = byHandle[c.cover];
    return `<a class="coll reveal" style="--d:${i * .06}s" ${catLink(c.id)} aria-label="${esc(c.label)}">
      <div class="coll__img">${productImg(p, 480)}</div>
      <div class="coll__label"><span>${esc(c.label)}</span>${ICON_ARROW}</div>
    </a>`;
  }).join('');
})();

/* =====================================================================
   PRODUCT CARD
   ===================================================================== */
function cardHTML(p, i = 0) {
  const imgs = p.images.length
    ? `<img class="main" src="${esc(sized(p.images[0], 640))}" alt="${esc(p.title)}" loading="lazy" decoding="async" width="640" height="800">` +
      (p.images[1] ? `<img class="alt" src="${esc(sized(p.images[1], 640))}" alt="" aria-hidden="true" loading="lazy" decoding="async" width="640" height="800">` : '')
    : placeholder(`Image placeholder for ${p.title}`);
  const tag = tagLabel(p);
  const addLabel = !p.available ? `Sold out: ${esc(p.title)}` : (p.variants.length > 1 ? 'Choose options for ' : 'Add to cart: ') + esc(p.title);
  return `<article class="card" style="--i:${i}">
    <div class="card__media">
      <a href="${esc(p.url)}" tabindex="-1" aria-hidden="true">${imgs}</a>
      ${tag ? `<span class="card__tag">${esc(tag)}</span>` : ''}
      <button class="card__quick" data-qv="${esc(p.handle)}" aria-label="Quick view: ${esc(p.title)}">Quick view</button>
    </div>
    <div class="card__body">
      <h3 class="card__title"><a href="${esc(p.url)}">${esc(p.title)}</a></h3>
      <p class="card__price">${priceText(p)}</p>
      <button class="card__add" data-add="${esc(p.handle)}" aria-label="${addLabel}" ${p.available ? '' : 'disabled'}>${ICON_PLUS}</button>
    </div>
  </article>`;
}

/* Featured */
if ($('#featuredGrid')) {
  $('#featuredGrid').innerHTML = pick(FEATURED).map((p, i) => cardHTML(p, i)).join('');
  $$('#featuredGrid .card').forEach((c, i) => { c.classList.add('reveal'); c.style.setProperty('--d', (i % 4) * .08 + 's'); });
}

/* Mini product rows in editorials */
$$('[data-minis]').forEach(el => {
  el.innerHTML = pick(el.dataset.minis.split(',')).map(p =>
    `<a class="mini" href="${esc(p.url)}" aria-label="${esc(p.title)}, ${priceText(p)}">
      <span class="mini__img">${productImg(p, 160)}</span>
      <span><span class="mini__title" style="display:block">${esc(p.title)}</span><span class="mini__price" style="display:block">${priceText(p)}</span></span>
      <span class="mini__cta" aria-hidden="true">View</span>
    </a>`).join('');
});

/* Marquee */
(function marquee() {
  if (!$('#marquee')) return;
  const group = '<div class="marquee__group">' + CONFIG.marquee.map(w => `<span class="marquee__item">${esc(w)}</span><span class="marquee__dot"></span>`).join('') + '</div>';
  $('#marquee').innerHTML = group + group;
})();

/* Everyday themes */
if ($('#themes')) $('#themes').innerHTML = EVERYDAY.map((t, i) => {
  const b = BANNERS[t.banner] || {};
  return `<article class="theme reveal" style="--d:${i * .08}s">
    <div class="theme__img">${bannerImg(b, `loading="lazy" sizes="(max-width: 600px) 100vw, (max-width: 1080px) 50vw, 25vw" style="object-position:${esc(b.pos)}"`)}<span class="theme__num" aria-hidden="true">0${i + 1}</span></div>
    <div class="theme__body">
      <h3>${esc(t.title)}</h3>
      <p>${esc(t.text)}</p>
      <ul class="theme__items" aria-label="Featured products">${pick(t.items).map(p => `<li><a href="${esc(p.url)}">${esc(p.title.split(/ — | with /)[0])}</a></li>`).join('')}</ul>
      <a class="link-arrow" ${catLink(t.category)}>${esc(t.cta)} ${ICON_ARROW}</a>
    </div>
  </article>`;
}).join('');

/* =====================================================================
   DISCOVERY TABS
   ===================================================================== */
const Discovery = (function () {
  const tabsEl = $('#tabs'), grid = $('#discGrid'), pill = $('#tabsPill');
  if (!tabsEl) return null;
  const tabs = [{ id: 'all', label: 'All' }, ...CATEGORIES];
  let current = 'all', sort = 'featured', shown = CONFIG.discoveryPageSize;
  tabsEl.insertAdjacentHTML('beforeend', tabs.map(t => {
    const n = t.id === 'all' ? PRODUCTS.length : PRODUCTS.filter(p => p.category === t.id).length;
    return `<button class="tab" role="tab" id="tab-${t.id}" data-tab="${t.id}" aria-selected="${t.id === 'all'}" aria-controls="discPanel" tabindex="${t.id === 'all' ? 0 : -1}">${esc(t.label)}<span class="n">${n}</span></button>`;
  }).join(''));
  const tabEls = $$('.tab', tabsEl);

  function movePill() {
    const t = tabEls.find(x => x.dataset.tab === current);
    pill.style.width = t.offsetWidth + 'px';
    pill.style.transform = `translateX(${t.offsetLeft}px)`;
  }
  function list() {
    let arr = PRODUCTS.filter(p => current === 'all' || p.category === current);
    // "Featured" order: alternate categories so the grid feels curated; image-less and sold-out items last
    if (sort === 'featured') {
      const good = p => p.images.length && p.available;
      const withImg = arr.filter(good), buckets = [...CATEGORIES.map(c => withImg.filter(p => p.category === c.id)), withImg.filter(p => !p.category)];
      const mixed = []; while (buckets.some(b => b.length)) buckets.forEach(b => b.length && mixed.push(b.shift()));
      arr = [...mixed, ...arr.filter(p => !good(p))];
    }
    if (sort === 'price-asc') arr = [...arr].sort((a, b) => a.price - b.price);
    if (sort === 'price-desc') arr = [...arr].sort((a, b) => b.price - a.price);
    if (sort === 'az') arr = [...arr].sort((a, b) => a.title.localeCompare(b.title));
    return arr;
  }
  function render(animate = true, appendFrom = 0) {
    const arr = list(), vis = arr.slice(0, shown);
    const paint = () => {
      if (appendFrom) grid.insertAdjacentHTML('beforeend', vis.slice(appendFrom).map((p, i) => cardHTML(p, i)).join(''));
      else grid.innerHTML = vis.map((p, i) => cardHTML(p, i)).join('');
      grid.classList.remove('is-leaving');
      $('#discStatus').textContent = `Showing ${vis.length} of ${arr.length} products`;
      $('#discProg').style.transform = `scaleX(${arr.length ? vis.length / arr.length : 1})`;
      const more = $('#discMore');
      more.hidden = vis.length >= arr.length;
      more.textContent = `Show more (${arr.length - vis.length})`;
    };
    if (animate && !appendFrom && !reduceMotion.matches) { grid.classList.add('is-leaving'); setTimeout(paint, 260); }
    else paint();
  }
  function select(id, scroll) {
    if (!tabs.some(t => t.id === id)) id = 'all';
    const changed = id !== current;
    current = id; shown = CONFIG.discoveryPageSize;
    tabEls.forEach(t => { const on = t.dataset.tab === id; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; });
    $('#discPanel').setAttribute('aria-labelledby', 'tab-' + id);
    movePill();
    const active = tabEls.find(t => t.dataset.tab === id);
    tabsEl.scrollTo({ left: active.offsetLeft - 24, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    if (changed) render(true);
    if (scroll) $('#discover').scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  }
  tabsEl.addEventListener('click', e => { const t = e.target.closest('.tab'); if (t) select(t.dataset.tab); });
  tabsEl.addEventListener('keydown', e => {
    const i = tabEls.findIndex(t => t.dataset.tab === current);
    let j = null;
    if (e.key === 'ArrowRight') j = (i + 1) % tabEls.length;
    if (e.key === 'ArrowLeft') j = (i - 1 + tabEls.length) % tabEls.length;
    if (e.key === 'Home') j = 0;
    if (e.key === 'End') j = tabEls.length - 1;
    if (j !== null) { e.preventDefault(); select(tabEls[j].dataset.tab); tabEls[j].focus(); }
  });
  $('#sortSel').addEventListener('change', e => { sort = e.target.value; shown = CONFIG.discoveryPageSize; render(true); });
  $('#discMore').addEventListener('click', () => {
    const from = shown; shown += CONFIG.discoveryPageSize; render(false, from);
    const next = grid.children[from]; if (next) { const a = next.querySelector('.card__title a'); a && a.focus({ preventScroll: true }); }
  });
  addEventListener('resize', movePill);
  document.fonts && document.fonts.ready.then(movePill);
  render(false); movePill();
  return { select };
})();

/* =====================================================================
   COLLECTION PAGE (sections/paw-edit-collection.liquid)
   Category tabs switch in place and update the URL; price, stock and sort
   are kept in the query string. Intros and promo tiles come from section blocks.
   ===================================================================== */
const Browse = (function () {
  const grid = $('#plpGrid'); if (!grid) return null;
  const COLL = DATA.collection || {};
  const PAGE = 12;
  const tabsEl = $('#plpTabs'), pill = $('#plpPill');
  const norm = u => (u || '').replace(/[?#].*$/, '').replace(/\/+$/, '').toLowerCase();
  let money0 = money;
  try { const f0 = new Intl.NumberFormat(CONFIG.locale, { style: 'currency', currency: CONFIG.currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }); money0 = c => f0.format(c / 100); } catch (e) { /* keep money */ }
  const BANDS = [
    { id: 'u20', min: 0, max: 2000 },
    { id: '20-35', min: 2000, max: 3500 },
    { id: '35-50', min: 3500, max: 5000 },
    { id: '50', min: 5000, max: Infinity },
  ].map(b => ({ ...b, label: !b.min ? `Under ${money0(b.max)}` : b.max === Infinity ? `${money0(b.min)}+` : `${money0(b.min)}–${money0(b.max)}` }));
  const SORTS = ['featured', 'price-asc', 'price-desc', 'az'];

  /* Tabs: All + the six categories; a collection outside them gets its own tab */
  const tabs = [{ id: 'all', label: 'All', url: ALL_URL }, ...CATEGORIES.map(c => ({ id: c.id, label: c.label, url: c.url }))];
  const collHandles = COLL.handles || [];
  const tabByUrl = url => tabs.find(t => t.url && norm(t.url) === norm(url));
  if (!tabByUrl(location.pathname) && COLL.url && norm(COLL.url) !== norm(ALL_URL) && collHandles.length) {
    tabs.splice(1, 0, { id: 'coll', label: COLL.title, url: COLL.url });
  }
  const tabById = id => tabs.find(t => t.id === id);
  const tabHref = t => t.url || `${ALL_URL}?cat=${t.id}`;
  function fromLocation() {
    const q = new URLSearchParams(location.search), cat = q.get('cat');
    const t = (cat && tabById(cat)) || tabByUrl(location.pathname);
    return {
      id: t ? t.id : 'all',
      sort: SORTS.includes(q.get('sort')) ? q.get('sort') : 'featured',
      band: BANDS.some(b => b.id === q.get('price')) ? q.get('price') : '',
      stock: q.get('stock') === '1',
    };
  }
  const start = fromLocation();
  let current = start.id, sort = start.sort, band = start.band, stockOnly = start.stock, shown = PAGE;

  const inTab = (p, id) => id === 'all' || (id === 'coll' ? collHandles.includes(p.handle) : p.category === id);
  const inBand = (p, id = band) => { const b = BANDS.find(x => x.id === id); return !b || (p.price >= b.min && p.price < b.max); };
  const good = p => !!(p.images.length && p.available);
  const base = () => PRODUCTS.filter(p => inTab(p, current));

  /* "Featured": on All, alternate categories so the grid feels curated; elsewhere keep the collection's own order */
  function featured(arr) {
    if (current === 'all') {
      const withImg = arr.filter(good), buckets = [...CATEGORIES.map(c => withImg.filter(p => p.category === c.id)), withImg.filter(p => !p.category)];
      const mixed = []; while (buckets.some(b => b.length)) buckets.forEach(b => b.length && mixed.push(b.shift()));
      return [...mixed, ...arr.filter(p => !good(p))];
    }
    const order = current === 'coll' ? collHandles : ((CAT_DATA[current] || {}).handles || []);
    const rank = p => { const i = order.indexOf(p.handle); return i < 0 ? order.length : i; };
    return arr.sort((a, b) => (good(b) - good(a)) || (rank(a) - rank(b)));
  }
  function list() {
    const arr = base().filter(p => (!stockOnly || p.available) && inBand(p));
    if (sort === 'price-asc') return arr.sort((a, b) => a.price - b.price);
    if (sort === 'price-desc') return arr.sort((a, b) => b.price - a.price);
    if (sort === 'az') return arr.sort((a, b) => a.title.localeCompare(b.title));
    return featured(arr);
  }

  /* Promo tiles (section blocks): shown on one tab at a grid position, hidden while filtering */
  const PROMOS = (DATA.promos || []).map(pr => {
    const t = pr.show ? tabByUrl(pr.show) : tabs[0], target = pr.url && tabByUrl(pr.url);
    return { ...pr, tab: t ? t.id : null, at: Math.max(1, +pr.at || 5) - 1, target: target ? target.id : '' };
  }).filter(pr => pr.tab && (pr.heading || (pr.image && pr.image.src)));
  function promoHTML(pr, i) {
    const b = pr.image || {};
    return `<a class="promo" href="${esc(pr.url || ALL_URL)}" style="--i:${i}"${pr.target && pr.target !== current ? ` data-tab="${pr.target}"` : ''}>
      <div class="promo__media">${bannerImg(b, `loading="lazy" decoding="async" sizes="(max-width: 720px) 100vw, 50vw" style="object-position:${esc(b.pos || 'center')}"`)}</div>
      <div class="promo__copy">
        ${pr.eyebrow ? `<span class="eyebrow">${esc(pr.eyebrow)}</span>` : ''}
        <span class="promo__title">${esc(pr.heading)}${pr.italic ? ` <em class="h-italic">${esc(pr.italic)}</em>` : ''}</span>
        ${pr.cta ? `<span class="link-arrow">${esc(pr.cta)} ${ICON_ARROW}</span>` : ''}
      </div>
    </a>`;
  }
  function itemsHTML(vis, from) {
    const promos = band || stockOnly ? [] : PROMOS.filter(pr => pr.tab === current && pr.at >= from && pr.at < vis.length);
    let out = '', n = 0;
    for (let i = from; i < vis.length; i++) {
      promos.filter(pr => pr.at === i).forEach(pr => { out += promoHTML(pr, n++); });
      out += cardHTML(vis[i], n++);
    }
    return out;
  }

  /* Tabs */
  tabsEl.insertAdjacentHTML('beforeend', tabs.map(t =>
    `<a class="tab" href="${esc(tabHref(t))}" data-tab="${t.id}">${esc(t.label)}<span class="n">${PRODUCTS.filter(p => inTab(p, t.id)).length}</span></a>`).join(''));
  const tabEls = $$('.tab', tabsEl);
  function movePill() {
    const a = tabEls.find(x => x.dataset.tab === current); if (!a) return;
    pill.style.width = a.offsetWidth + 'px';
    pill.style.transform = `translateX(${a.offsetLeft}px)`;
  }
  function syncTabs(smooth) {
    tabEls.forEach(a => a.dataset.tab === current ? a.setAttribute('aria-current', 'page') : a.removeAttribute('aria-current'));
    movePill();
    const a = tabEls.find(x => x.dataset.tab === current);
    tabsEl.scrollTo({ left: a.offsetLeft - 24, behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto' });
    const here = norm(tabHref(tabById(current)));
    $$('#primaryNav a, #mobileNav a').forEach(l => norm(l.getAttribute('href')) === here ? l.setAttribute('aria-current', 'page') : l.removeAttribute('aria-current'));
  }

  /* Hero: intro copy per collection (section blocks), product count and an image collage */
  const INTROS = DATA.intros || [];
  function introFor(id) {
    const t = tabById(id);
    const hit = INTROS.find(it => it.heading && (id === 'all' ? (!it.url || norm(it.url) === norm(ALL_URL)) : (it.url && norm(it.url) === norm(t.url))));
    if (hit) return hit;
    if (id === 'coll') return { eyebrow: 'Collection', heading: COLL.title, text: COLL.description };
    return { eyebrow: id === 'all' ? 'Shop all' : 'Shop', heading: id === 'all' ? 'Everything in the edit' : t.label, text: '' };
  }
  function hero(animate) {
    const it = introFor(current), n = base().length, t = tabById(current);
    const eb = $('#plpEyebrow'); eb.textContent = it.eyebrow || ''; eb.hidden = !it.eyebrow;
    $('#plpTitle').innerHTML = esc(it.heading) + (it.italic ? ` <em class="h-italic">${esc(it.italic)}</em>` : '');
    $('#plpText').textContent = it.text || '';
    $('#plpCount').textContent = n;
    $('#plpCountLbl').textContent = n === 1 ? 'product' : 'products';
    $('#plpCrumb').textContent = current === 'all' ? 'Shop all' : t.label;
    if (DATA.shopName) document.title = `${current === 'all' ? 'Shop all' : t.label} – ${DATA.shopName}`;
    $('#plpCollage').innerHTML = featured(base()).filter(p => p.images.length).slice(0, 3).map((p, i) =>
      `<div class="collage__item" style="--i:${i}"><img src="${esc(sized(p.images[0], 480))}" alt="" width="480" height="600" decoding="async"></div>`).join('');
    if (animate) { const c = $('#plpCopy'); c.classList.remove('swap'); void c.offsetWidth; c.classList.add('swap'); }
  }

  /* Refine row: price chips with live counts, in-stock switch, clear */
  function renderRefine() {
    const pool = base().filter(p => !stockOnly || p.available);
    $('#plpPrice').innerHTML = BANDS.map(b => {
      const n = pool.filter(p => inBand(p, b.id)).length, on = band === b.id;
      return `<button type="button" class="chip" data-band="${b.id}" aria-pressed="${on}"${n || on ? '' : ' disabled'}>${esc(b.label)}<span class="n">${n}</span></button>`;
    }).join('');
    $('#plpStockWrap').hidden = PRODUCTS.every(p => p.available);
    $('#plpStock').checked = stockOnly;
    $('#plpClear').hidden = !band && !stockOnly;
    $('#plpSort').value = sort;
  }

  function paint(from) {
    const arr = list(), vis = arr.slice(0, shown);
    if (from) grid.insertAdjacentHTML('beforeend', itemsHTML(vis, from));
    else grid.innerHTML = itemsHTML(vis, 0);
    grid.classList.remove('is-leaving');
    $('#plpEmpty').hidden = arr.length > 0;
    $('#plpEmptyClear').hidden = !band && !stockOnly;
    $('#plpResults').textContent = `${arr.length} product${arr.length === 1 ? '' : 's'}`;
    $('#plpMoreWrap').hidden = !arr.length;
    $('#plpStatus').textContent = `Showing ${vis.length} of ${arr.length} products`;
    $('#plpProg').style.transform = `scaleX(${arr.length ? vis.length / arr.length : 1})`;
    const more = $('#plpMore');
    more.hidden = vis.length >= arr.length;
    more.textContent = `Show more (${arr.length - vis.length})`;
  }
  let paintT;
  function render(animate) {
    clearTimeout(paintT);
    if (animate && !reduceMotion.matches && grid.children.length) { grid.classList.add('is-leaving'); paintT = setTimeout(() => paint(0), 260); }
    else paint(0);
  }

  function qs() {
    const q = new URLSearchParams();
    if (!tabById(current).url) q.set('cat', current);
    if (sort !== 'featured') q.set('sort', sort);
    if (band) q.set('price', band);
    if (stockOnly) q.set('stock', '1');
    const s = q.toString(); return s ? '?' + s : '';
  }
  const urlNow = () => (tabById(current).url || ALL_URL) + qs();
  function toTop() {
    const top = $('#plpTop');
    if (top.getBoundingClientRect().top < 0) top.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  }
  function select(id, scroll, push = true) {
    if (!tabById(id)) id = 'all';
    const changed = id !== current;
    current = id; shown = PAGE;
    if (band && !base().some(p => inBand(p))) band = '';     // drop a price filter the new tab can't satisfy
    if (push && changed) history.pushState({ plp: id }, '', urlNow());
    syncTabs(true); renderRefine(); hero(changed);
    if (changed) render(true);
    if (scroll || changed) toTop();
  }
  function refined() {
    shown = PAGE;
    history.replaceState(history.state, '', urlNow());
    renderRefine(); render(true);
  }
  const plainClick = e => !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button);

  tabsEl.addEventListener('click', e => {
    const a = e.target.closest('[data-tab]'); if (!a || !plainClick(e)) return;
    e.preventDefault(); select(a.dataset.tab);
  });
  grid.addEventListener('click', e => {
    const a = e.target.closest('.promo[data-tab]'); if (!a || !plainClick(e)) return;
    e.preventDefault(); select(a.dataset.tab, true);
  });
  /* Header, menu and footer links to a category switch in place too */
  document.addEventListener('click', e => {
    const a = e.target.closest && e.target.closest('#primaryNav a, #mobileNav a, #footShop a');
    if (!a || !plainClick(e)) return;
    const href = a.getAttribute('href') || '', cat = (href.match(/[?&]cat=([\w-]+)/) || [])[1];
    const t = (cat && tabById(cat)) || (!href.startsWith('#') && tabByUrl(href));
    if (!t) return;
    e.preventDefault();
    const d = a.closest('dialog'); if (d) closeDialog(d);
    select(t.id, true);
  });
  $('#plpPrice').addEventListener('click', e => {
    const b = e.target.closest('[data-band]'); if (!b || b.disabled) return;
    band = band === b.dataset.band ? '' : b.dataset.band;
    refined();
    const again = $(`#plpPrice [data-band="${b.dataset.band}"]`); again && again.focus();
  });
  $('#plpStock').addEventListener('change', e => { stockOnly = e.target.checked; refined(); });
  const clear = () => { band = ''; stockOnly = false; refined(); const c = $('#plpPrice .chip'); c && c.focus(); };
  $('#plpClear').addEventListener('click', clear);
  $('#plpEmptyClear').addEventListener('click', clear);
  $('#plpSort').addEventListener('change', e => { sort = e.target.value; refined(); });
  $('#plpMore').addEventListener('click', () => {
    const before = grid.children.length, from = shown;
    shown += PAGE; paint(from);
    const next = grid.children[before];
    const f = next && (next.matches('a') ? next : next.querySelector('.card__title a'));
    f && f.focus({ preventScroll: true });
  });
  addEventListener('popstate', () => {
    const s = fromLocation();
    sort = s.sort; band = s.band; stockOnly = s.stock;
    if (s.id !== current) select(s.id, false, false);
    else { shown = PAGE; renderRefine(); render(true); }
  });
  addEventListener('resize', movePill);
  document.fonts && document.fonts.ready.then(movePill);

  history.replaceState({ plp: current }, '', location.href);
  syncTabs(false); renderRefine(); hero(false); paint(0);
  return { select };
})();

/* =====================================================================
   QUICK VIEW
   ===================================================================== */
const QuickView = (function () {
  const dlg = $('#qvDialog'), box = $('#qvContent');
  let p = null, vi = 0, qty = 1;
  function firstAvailable(prod) { const i = prod.variants.findIndex(v => v.available); return i < 0 ? 0 : i; }
  function open(handle, opener) {
    p = byHandle[handle]; if (!p) return; vi = firstAvailable(p); qty = 1;
    const imgs = p.images, opts = p.opts;
    const many = opts.length > 8;
    const optLabel = p.optionName || 'Option';
    const v0 = p.variants[vi];
    box.innerHTML = `
      <div class="qv__gallery">
        <div class="qv__main" id="qvMain">${imgs.length ? `<img src="${esc(sized(imgs[0], 900))}" alt="${esc(p.title)}, image 1 of ${imgs.length}" width="900" height="900">` : placeholder('Image placeholder for ' + p.title)}</div>
        ${imgs.length > 1 ? `<div class="qv__thumbs" role="group" aria-label="Product images">${imgs.map((src, i) =>
          `<button class="qv__thumb" data-i="${i}" aria-label="Show image ${i + 1}" aria-current="${i === 0}"><img src="${esc(sized(src, 160))}" alt="" loading="lazy" width="64" height="64"></button>`).join('')}</div>` : ''}
      </div>
      <div class="qv__info">
        ${tagLabel(p) ? `<span class="eyebrow">${esc(tagLabel(p))}</span>` : ''}
        <h2 id="qvTitle">${esc(p.title)}</h2>
        <div class="qv__price" id="qvPrice">${money(v0 ? v0.price : p.price)}</div>
        <p class="qv__blurb">${esc(p.blurb)}</p>
        ${opts.length ? (many
          ? `<div><label class="opt-label" for="qvSelect">${esc(optLabel)}</label><select id="qvSelect">${opts.map((v, i) => `<option value="${i}" ${i === vi ? 'selected' : ''}>${esc(v.label)}${v.price !== opts[0].price ? ' · ' + money(v.price) : ''}${v.available ? '' : ' · Sold out'}</option>`).join('')}</select></div>`
          : `<div><span class="opt-label" id="qvOptLbl">${esc(optLabel)}: <span id="qvOptVal">${esc(opts[vi].label)}</span></span><div class="chips" role="radiogroup" aria-labelledby="qvOptLbl">${opts.map((v, i) =>
              `<button class="chip" role="radio" data-v="${i}" aria-checked="${i === vi}" tabindex="${i === vi ? 0 : -1}">${esc(v.label)}${v.available ? '' : ' (sold out)'}</button>`).join('')}</div></div>`) : ''}
        <div class="qv__buy">
          <div class="qty" role="group" aria-label="Quantity">
            <button type="button" data-q="-1" aria-label="Decrease quantity"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg></button>
            <output id="qvQty" aria-live="polite">1</output>
            <button type="button" data-q="1" aria-label="Increase quantity">${ICON_PLUS.replace('viewBox', 'width="14" height="14" viewBox')}</button>
          </div>
          <button class="btn" id="qvAdd">Add to cart <span class="arrow">${ICON_ARROW}</span></button>
        </div>
        <div class="qv__meta">
          <a class="link-arrow" href="${esc(p.url)}">Full product details ${ICON_ARROW}</a>
        </div>
      </div>`;
    wire();
    syncBuy();
    openDialog(dlg, opener);
  }
  function syncBuy() {
    const v = p.variants[vi], btn = $('#qvAdd');
    const ok = v && v.available;
    btn.disabled = !ok;
    btn.innerHTML = ok ? `Add to cart <span class="arrow">${ICON_ARROW}</span>` : 'Sold out';
  }
  function setVariant(i) {
    vi = i;
    $('#qvPrice').textContent = money(p.variants[i].price);
    const val = $('#qvOptVal'); if (val) val.textContent = p.variants[i].label;
    $$('.chip', box).forEach((c, j) => { c.setAttribute('aria-checked', j === i); c.tabIndex = j === i ? 0 : -1; });
    syncBuy();
  }
  function wire() {
    $$('.qv__thumb', box).forEach(t => t.addEventListener('click', () => {
      const i = +t.dataset.i, img = $('#qvMain img');
      img.style.opacity = 0;
      setTimeout(() => { img.src = sized(p.images[i], 900); img.alt = `${p.title}, image ${i + 1} of ${p.images.length}`; img.onload = () => img.style.opacity = 1; }, 180);
      $$('.qv__thumb', box).forEach(x => x.setAttribute('aria-current', x === t));
    }));
    const chips = $$('.chip', box);
    chips.forEach(c => {
      c.addEventListener('click', () => setVariant(+c.dataset.v));
      c.addEventListener('keydown', e => {
        const d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
        if (!d) return; e.preventDefault();
        const j = (vi + d + chips.length) % chips.length; setVariant(j); chips[j].focus();
      });
    });
    const sel = $('#qvSelect'); if (sel) sel.addEventListener('change', () => setVariant(+sel.value));
    $$('[data-q]', box).forEach(b => b.addEventListener('click', () => { qty = Math.max(1, Math.min(20, qty + +b.dataset.q)); $('#qvQty').textContent = qty; }));
    $('#qvAdd').addEventListener('click', async () => {
      const v = p.variants[vi]; if (!v || !v.available) return;
      const btn = $('#qvAdd'); btn.disabled = true;
      const ok = await Cart.add(v.id, qty, p.title);
      btn.disabled = false;
      if (ok) closeDialog(dlg);
    });
  }
  return { open };
})();

/* =====================================================================
   CART (Shopify AJAX cart: /cart.js, /cart/add.js, /cart/change.js)
   ===================================================================== */
const Cart = (function () {
  let state = { items: [], item_count: 0, total_price: 0 };
  const dlg = $('#cartDrawer');
  const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  async function refresh() {
    try {
      const r = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (r.ok) { state = await r.json(); render(); }
    } catch (e) { /* keep last known state */ }
  }
  async function add(variantId, qty, title) {
    try {
      const r = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: JSON_HEADERS, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }) });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) { toast(data.description || data.message || 'Sorry, this item could not be added.'); return false; }
      await refresh();
      const btn = $('#cartOpen'); btn.classList.remove('bump'); void btn.offsetWidth; btn.classList.add('bump');
      toast(`Added to cart: ${title}`);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: state }));
      return true;
    } catch (e) { toast('Connection problem. Please try again.'); return false; }
  }
  async function change(key, quantity) {
    try {
      const r = await fetch(ROOT + 'cart/change.js', { method: 'POST', headers: JSON_HEADERS, credentials: 'same-origin', body: JSON.stringify({ id: key, quantity }) });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) { toast(data.description || data.message || 'Sorry, the cart could not be updated.'); await refresh(); return; }
      state = data; render();
    } catch (e) { toast('Connection problem. Please try again.'); }
  }
  function lineImg(it) {
    const src = it.featured_image && it.featured_image.url || it.image;
    return src ? `<img src="${esc(sized(src, 200))}" alt="${esc(it.product_title)}" loading="lazy" width="76" height="92">` : placeholder('Image placeholder for ' + it.product_title);
  }
  function render() {
    const count = state.item_count || 0, items = state.items || [];
    const c = $('#cartCount'); c.textContent = count; c.classList.toggle('has-items', count > 0);
    $('#cartOpen').setAttribute('aria-label', `Open cart, ${count} item${count === 1 ? '' : 's'}`);
    $('#cartSubtotal').textContent = money(state.total_price);
    $('#cartFoot').hidden = !items.length;
    $('#cartBody').innerHTML = items.length ? items.map((it, i) => {
      const variant = it.product_has_only_default_variant ? '' : (it.variant_title || '');
      return `<div class="cart-line">
        <a class="cart-line__img" href="${esc(it.url)}">${lineImg(it)}</a>
        <div>
          <div class="cart-line__title"><a href="${esc(it.url)}">${esc(it.product_title)}</a></div>
          ${variant ? `<div class="cart-line__var">${esc(variant)}</div>` : ''}
          <div class="qty" role="group" aria-label="Quantity for ${esc(it.product_title)}">
            <button data-line="${i}" data-d="-1" aria-label="Decrease quantity"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg></button>
            <output>${it.quantity}</output>
            <button data-line="${i}" data-d="1" aria-label="Increase quantity">${ICON_PLUS.replace('viewBox', 'width="14" height="14" viewBox')}</button>
          </div>
        </div>
        <div class="cart-line__side">
          <span class="cart-line__price">${money(it.final_line_price)}</span>
          <button class="remove" data-remove="${i}">Remove<span class="visually-hidden"> ${esc(it.product_title)}</span></button>
        </div>
      </div>`;
    }).join('') : `<div class="cart-empty"><h3>Your cart is empty</h3><p>Browse the edit and add a few favourites.</p><a class="btn" href="${esc(ALL_URL)}">Start shopping ${ICON_ARROW}</a></div>`;
  }
  $('#cartBody').addEventListener('click', async e => {
    const d = e.target.closest('[data-d]'), r = e.target.closest('[data-remove]');
    if (d) {
      const i = +d.dataset.line, it = state.items[i]; if (!it) return;
      d.disabled = true;
      await change(it.key, Math.max(0, it.quantity + +d.dataset.d));
      const again = $(`#cartBody [data-line="${i}"][data-d="${d.dataset.d}"]`); again && again.focus();
    }
    if (r) {
      const it = state.items[+r.dataset.remove]; if (!it) return;
      r.disabled = true;
      await change(it.key, 0);
      $('#cartDrawer .icon-btn').focus();
    }
  });
  $('#cartOpen').addEventListener('click', e => { openDialog(dlg, e.currentTarget); refresh(); });
  addEventListener('pageshow', e => { if (e.persisted) refresh(); });
  render(); refresh();
  return { add, refresh };
})();

/* =====================================================================
   PRODUCT PAGE (sections/paw-edit-product.liquid)
   Gallery, option picker, AJAX add to cart, sticky buy bar, related and
   recently viewed products. The Liquid form still posts to /cart/add without JS.
   ===================================================================== */
(function productPage() {
  const root = $('#pdp'), P = DATA.product;
  if (!root || !P) return;
  const form = $('#pdpForm'), idInput = $('input[name="id"]', form);
  let variant = P.variants.find(v => v.id === P.selected) || P.variants[0];
  let selected = variant.options.slice(), qty = 1;

  /* Gallery: scroll-snap track with thumbnails, arrows, counter and dots */
  const track = $('#pdpTrack'), slides = $$('.pdp-slide', track), thumbs = $$('.pdp-thumb', root), dots = $$('.pdp-dot', root);
  const prev = $('#pdpPrev'), next = $('#pdpNext');
  let cur = 0;
  function mark(i) {
    cur = i;
    thumbs.forEach((t, j) => t.setAttribute('aria-current', j === i));
    dots.forEach((d, j) => d.classList.toggle('is-on', j === i));
    const c = $('#pdpCounter'); if (c) c.textContent = `${i + 1} / ${slides.length}`;
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i === slides.length - 1;
    const t = thumbs[i], box = t && t.parentElement;           // keep the active thumbnail visible without moving the page
    if (t && (t.offsetTop < box.scrollTop || t.offsetTop + t.offsetHeight > box.scrollTop + box.clientHeight)) box.scrollTo({ top: t.offsetTop - 8 });
  }
  function goTo(i, smooth = true) {
    if (slides.length < 2) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto' });
    mark(i);
  }
  if (slides.length > 1) {
    thumbs.forEach(t => t.addEventListener('click', () => goTo(+t.dataset.i)));
    prev && prev.addEventListener('click', () => goTo(cur - 1));
    next && next.addEventListener('click', () => goTo(cur + 1));
    track.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(cur - 1); }
    });
    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return; ticking = true;
      requestAnimationFrame(() => { ticking = false; const i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur) mark(i); });
    }, { passive: true });
  }

  /* Options: pick values per option, resolve the variant, grey out combinations that are sold out or missing */
  const groups = $$('.pdp-opt', root);
  const matchFor = (oi, val) => P.variants.find(v => v.options[oi] === val && v.options.every((o, k) => k === oi || o === selected[k]));
  function renderOptions() {
    groups.forEach(g => {
      const oi = +g.dataset.opt;
      $$('[data-val]', g).forEach(b => {
        const on = selected[oi] === b.dataset.val, m = matchFor(oi, b.dataset.val);
        b.setAttribute('aria-checked', on); b.tabIndex = on ? 0 : -1;
        b.classList.toggle('is-unavailable', !m || !m.available);
        b.setAttribute('aria-label', b.dataset.val + (!m ? ' (unavailable)' : !m.available ? ' (sold out)' : ''));
      });
      const sel = $('select', g); if (sel) sel.value = selected[oi];
      $('.pdp-opt__val', g).textContent = selected[oi];
    });
  }
  function choose(oi, val) {
    selected[oi] = val;
    const v = P.variants.find(x => x.options.every((o, k) => o === selected[k]))
      || P.variants.find(x => x.options[oi] === val && x.available)
      || P.variants.find(x => x.options[oi] === val);
    if (!v) return;
    selected = v.options.slice();
    setVariant(v, true);
  }
  groups.forEach(g => {
    const oi = +g.dataset.opt, chips = $$('[data-val]', g);
    chips.forEach(b => {
      b.addEventListener('click', () => choose(oi, b.dataset.val));
      b.addEventListener('keydown', e => {
        const d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
        if (!d) return; e.preventDefault();
        const j = (chips.indexOf(b) + d + chips.length) % chips.length;
        choose(oi, chips[j].dataset.val); chips[j].focus();
      });
    });
    const sel = $('select', g); if (sel) sel.addEventListener('change', () => choose(oi, sel.value));
  });

  /* Price, stock and buttons for the current variant */
  const ADD_HTML = `Add to cart <span class="arrow">${ICON_ARROW}</span>`;
  function render() {
    const v = variant, sale = v.compare > v.price;
    $('#pdpPrice').innerHTML = `<span class="pdp-price__now${sale ? ' is-sale' : ''}">${money(v.price)}</span>` +
      (sale ? `<s class="pdp-price__was"><span class="visually-hidden">Regular price </span>${money(v.compare)}</s><span class="pdp-price__save">Save ${Math.floor((v.compare - v.price) * 100 / v.compare)}%</span>` : '');
    const low = v.available && v.inv != null && v.inv > 0 && v.inv <= 5;
    const s = $('#pdpStock');
    s.className = 'pdp-stock ' + (!v.available ? 'is-out' : low ? 'is-low' : 'is-in');
    s.lastElementChild.textContent = !v.available ? 'Sold out' : low ? `Only ${v.inv} left` : 'In stock';
    const add = $('#pdpAdd'), bar = $('#buybarAdd');
    add.disabled = bar.disabled = !v.available;
    add.innerHTML = v.available ? ADD_HTML : 'Sold out';
    bar.textContent = v.available ? 'Add to cart' : 'Sold out';
    $('#pdpDynamic').setAttribute('aria-disabled', !v.available);
    $('#buybarMeta').textContent = money(v.price) + (P.variants.length > 1 ? ' · ' + v.title : '');
  }
  function setVariant(v, fromUser) {
    variant = v; idInput.value = v.id;
    idInput.dispatchEvent(new Event('change', { bubbles: true }));   // keeps the dynamic checkout button in sync
    renderOptions(); render();
    if (fromUser) {
      if (v.img > 0) goTo(v.img - 1);
      try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u); } catch (e) { /* ignore */ }
    }
  }

  /* Quantity + add to cart (opens the cart drawer on success) */
  $$('[data-q]', form).forEach(b => b.addEventListener('click', () => {
    qty = Math.max(1, Math.min(99, qty + +b.dataset.q));
    $('#pdpQty').textContent = qty; $('#pdpQtyInput').value = qty;
  }));
  async function add(btn) {
    if (!variant.available || btn.disabled) return;
    btn.disabled = true;
    const ok = await Cart.add(variant.id, qty, P.title);
    btn.disabled = false; render();
    if (ok) openDialog($('#cartDrawer'), btn);
  }
  form.addEventListener('submit', e => { e.preventDefault(); add($('#pdpAdd')); });
  $('#buybarAdd').addEventListener('click', e => add(e.currentTarget));

  /* Sticky buy bar: shows once the main add button has scrolled out of view */
  const bar = $('#buybar');
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => {
      const show = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('is-show', show); bar.inert = !show;
    }).observe($('#pdpBuyRow'));
  }

  /* Share: native share sheet, else copy the link */
  $('#pdpShare').addEventListener('click', async () => {
    const url = location.href.split('#')[0];
    if (navigator.share) { try { await navigator.share({ title: P.title, url }); } catch (e) { /* cancelled */ } return; }
    try { await navigator.clipboard.writeText(url); toast('Link copied'); } catch (e) { toast('Copy this page’s address to share it.'); }
  });

  /* Short description from the design copy, when there is one */
  if (BLURBS[P.handle]) $('#pdpBlurb').textContent = BLURBS[P.handle];

  /* Related: same category first, then the rest of the catalog */
  const me = byHandle[P.handle], cat = me ? me.category : '';
  const pool = PRODUCTS.filter(p => p.handle !== P.handle && p.available && p.images.length);
  const related = [...pool.filter(p => cat && p.category === cat), ...pool.filter(p => !cat || p.category !== cat)].slice(0, 4);
  $('#pdpRelated').innerHTML = related.map((p, i) => cardHTML(p, i)).join('');
  if (!related.length) $('#pdpRelated').closest('section').hidden = true;

  /* Recently viewed (this browser only) */
  const KEY = 'paw-edit:recent';
  let recent = [];
  try { recent = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { /* storage unavailable */ }
  if (!Array.isArray(recent)) recent = [];
  const shownHandles = new Set(related.map(p => p.handle));
  const seen = pick(recent.filter(h => h !== P.handle && !shownHandles.has(h))).slice(0, 4);
  if (seen.length) { $('#pdpRecentGrid').innerHTML = seen.map((p, i) => cardHTML(p, i)).join(''); $('#pdpRecent').hidden = false; }
  try { localStorage.setItem(KEY, JSON.stringify([P.handle, ...recent.filter(h => h !== P.handle)].slice(0, 12))); } catch (e) { /* storage unavailable */ }

  setVariant(variant, false);
})();

/* =====================================================================
   SEARCH (instant results from the homepage catalog; Enter opens full search)
   ===================================================================== */
(function search() {
  const dlg = $('#searchDialog'), input = $('#searchInput'), out = $('#searchResults'), hint = $('#searchHint');
  const idle = () => `Searches all ${PRODUCTS.length} products. Press Enter to see every result.`;
  hint.textContent = idle();
  $('#searchSugs').innerHTML = ['Leash', 'Bed', 'Brush', 'Carrier', 'Bowl', 'Cat toy'].map(s => `<button type="button" class="chip" data-sug="${s}">${s}</button>`).join('');
  $('#searchSugs').addEventListener('click', e => { const b = e.target.closest('[data-sug]'); if (b) { input.value = b.dataset.sug; run(); input.focus(); } });
  $('#searchOpen').addEventListener('click', e => { openDialog(dlg, e.currentTarget); setTimeout(() => input.focus(), 50); });
  function run() {
    const q = input.value.trim().toLowerCase();
    if (!q) { out.innerHTML = ''; hint.textContent = idle(); return; }
    const terms = q.split(/\s+/);
    const res = PRODUCTS.filter(p => { const hay = (p.title + ' ' + tagLabel(p) + ' ' + p.blurb).toLowerCase(); return terms.every(t => hay.includes(t.replace(/s$/, ''))); });
    hint.textContent = res.length ? `${res.length} result${res.length > 1 ? 's' : ''} for “${input.value.trim()}”` : `No products match “${input.value.trim()}”. Try “leash” or “bed”.`;
    out.innerHTML = res.slice(0, 12).map(p => `<a class="mini" href="${esc(p.url)}"><span class="mini__img">${productImg(p, 160)}</span><span><span class="mini__title" style="display:block">${esc(p.title)}</span><span class="mini__price" style="display:block">${priceText(p)}</span></span><span class="mini__cta" aria-hidden="true">View</span></a>`).join('');
  }
  input.addEventListener('input', run);
})();

/* =====================================================================
   NEWSLETTER (Shopify customer form: validate, then submit)
   ===================================================================== */
(function newsletter() {
  const form = $('#newsForm'); if (!form) return;
  const msg = $('#newsMsg');
  form.addEventListener('submit', e => {
    const email = $('#newsEmail'), consent = $('#newsConsent');
    msg.classList.remove('err');
    if (!email.value || !email.checkValidity()) { e.preventDefault(); msg.textContent = 'Please enter a valid email address.'; msg.classList.add('err'); email.focus(); return; }
    if (!consent.checked) { e.preventDefault(); msg.textContent = 'Please tick the consent box to subscribe.'; msg.classList.add('err'); consent.focus(); return; }
    msg.textContent = 'Subscribing…';
  });
  if (msg.dataset.posted || msg.classList.contains('err') || /customer_posted=true/.test(location.search)) {
    setTimeout(() => $('#newsletter').scrollIntoView({ block: 'center' }), 300);
  }
})();

/* =====================================================================
   SCROLL REVEAL + PARALLAX
   ===================================================================== */
(function motion() {
  const els = $$('.reveal, .reveal-img');
  if (!('IntersectionObserver' in window) || reduceMotion.matches) { els.forEach(el => el.classList.add('is-in')); }
  else {
    const io = new IntersectionObserver(entries => entries.forEach(en => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: .12 });
    els.forEach(el => io.observe(el));
  }
  if (reduceMotion.matches) return;
  const px = $$('[data-parallax]'); let ticking = false;
  function update() {
    const vh = innerHeight;
    px.forEach(el => {
      const r = el.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      const prog = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.transform = `translate3d(0, ${(-Math.max(-1, Math.min(1, prog)) * parseFloat(el.dataset.parallax) * 50).toFixed(2)}%, 0)`;
    });
    ticking = false;
  }
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  addEventListener('resize', update); update();
})();

/* Fit the oversized footer wordmark to the container width */
(function fitFooterWord() {
  const el = $('.footer__big'); if (!el) return;
  const fit = () => { el.style.fontSize = ''; const base = parseFloat(getComputedStyle(el).fontSize);
    const ratio = el.clientWidth / el.scrollWidth; if (ratio < 1) el.style.fontSize = (base * ratio * 0.98) + 'px'; };
  fit(); addEventListener('resize', fit); document.fonts && document.fonts.ready.then(fit);
})();

/* Theme editor: when this section is re-rendered, reload so everything re-initialises */
document.addEventListener('shopify:section:load', e => { if (e.target && e.target.querySelector && e.target.querySelector('.paw-edit-root')) location.reload(); });
})();
